import { module } from "angular";
import { PhoneNumberTypeLabelComponent } from "./PhoneNumberTypeLabelComponent";

module("mmGui").component("irPhoneNumberTypeLabel", new PhoneNumberTypeLabelComponent());
